package app.alefly.quizengine

import app.alefly.domain.model.QuestionId
import kotlin.math.roundToInt

data class QuizGradedAnswer(
    val questionId: QuestionId,
    val selectedOptionId: String,
    val isCorrect: Boolean,
    val usedHint: Boolean,
    val answeredAtEpochMs: Long?,
)

object QuizScoreEngine {
    fun preview(
        answers: List<QuizGradedAnswer>,
        questionStartTimesMs: List<Long> = emptyList(),
        answerExpirationSeconds: Int = 30,
        maxPointsPerQuestion: Int = 100,
        minPointsPerQuestion: Int = 10,
    ): QuizScorePreview {
        val totalTimeMs = answerExpirationSeconds * 1000L
        var score = 0

        answers.forEachIndexed { index, answer ->
            if (!answer.isCorrect) return@forEachIndexed
            score += pointsFor(
                answer = answer,
                startMs = questionStartTimesMs.getOrNull(index),
                totalTimeMs = totalTimeMs,
                maxPointsPerQuestion = maxPointsPerQuestion,
                minPointsPerQuestion = minPointsPerQuestion,
            )
        }

        return QuizScorePreview(
            answeredCount = answers.size,
            correctCount = answers.count(QuizGradedAnswer::isCorrect),
            hintsUsedCount = answers.count(QuizGradedAnswer::usedHint),
            previewScore = score.coerceAtLeast(0),
        )
    }

    private fun pointsFor(
        answer: QuizGradedAnswer,
        startMs: Long?,
        totalTimeMs: Long,
        maxPointsPerQuestion: Int,
        minPointsPerQuestion: Int,
    ): Int {
        val answerMs = answer.answeredAtEpochMs
        if (startMs == null || answerMs == null || totalTimeMs <= 0) {
            return maxPointsPerQuestion
        }
        val elapsedMs = (answerMs - startMs).coerceAtLeast(0L)
        val remainingMs = (totalTimeMs - elapsedMs).coerceAtLeast(0L)
        val ratio = remainingMs.toDouble() / totalTimeMs.toDouble()
        val points = (minPointsPerQuestion + (maxPointsPerQuestion - minPointsPerQuestion) * ratio).roundToInt()
        return points.coerceIn(minPointsPerQuestion, maxPointsPerQuestion)
    }
}
